import home from '../screens/home.vue';

export const routes = [
    {path:'/eSocial/prazosEnvio', component: home}
];


// WEBPACK FOOTER //
// ./src/routes/index.js